module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_6.16e5b743.jpg";